import { jsx } from "react/jsx-runtime";
import { DialogActions } from "@mui/material";
import Button from "@mui/material/Button/index.js";
import { ThemeProvider } from "@mui/material/styles";
import { useLocaleText } from "@mui/x-date-pickers/internals/index.js";
import { createTheme } from "../../../constants/create-theme/create-theme.js";
import { MuiButton } from "../../../themes/button/button.js";
import { root } from "./pickers-action-bar.styles.js";
import "../../../constants/colors/palette.js";
import "../../../themes/shadows/shadows.js";
import "../../../themes/typography/typography.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
const theme = createTheme({ components: { MuiButton } });
const PickersActionBar = (props) => {
  const { onCancel, onAccept, actions, ...other } = props;
  const localeText = useLocaleText();
  const buttonProps = { size: "md", color: "aqua" };
  if (actions === null || (actions == null ? void 0 : actions.length) === 0) {
    return null;
  }
  const buttons = actions == null ? void 0 : actions.map((actionType) => {
    if (actionType === "cancel") {
      return /* @__PURE__ */ jsx(Button, { onClick: onCancel, variant: "borderless", ...buttonProps, children: localeText.cancelButtonLabel }, actionType);
    }
    if (actionType === "accept") {
      return /* @__PURE__ */ jsx(Button, { onClick: onAccept, variant: "shadowed", ...buttonProps, children: localeText.okButtonLabel }, actionType);
    }
    return null;
  });
  return /* @__PURE__ */ jsx(ThemeProvider, { theme, children: /* @__PURE__ */ jsx(DialogActions, { sx: root, ...other, children: buttons }) });
};
export {
  PickersActionBar
};
